import { Route, Routes } from 'react-router-dom'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { PortalPage } from '@/pages/PortalPage'
import { VoucherLinkPage } from '@/pages/VoucherLinkPage'

/**
 * ⚠️ Bu ilova "sahifalar" emas, BITTA oqim
 * (`docs/09-VENUE-PORTAL.md` §9: MikroTik `login.html` mehmonni
 * `/p?mac=...&nasid=...` ga yo'naltiradi). Bosqichlar orasidagi
 * o'tish React state bilan (`pages/PortalPage.tsx`), URL bilan EMAS —
 * captive portalda "orqaga" tugmasi OTP kod kiritish o'rtasida oqimni
 * chalkashtirmasin degan ataylab qaror.
 *
 * `/` ham `/p` ham bir xil sahifaga olib boradi: MikroTik konfiguratsiyasi
 * qaysi yo'lni ishlatishini oldindan bilib bo'lmaydi (`link-login-only`
 * kabi, deploy vaqtida router tomonidan belgilanadi).
 *
 * `/v` — kartadagi QR (`/v#t.<token>` yoki `/v#<kod>`): kartani eslab qoladi, oqim `/p` da.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PortalPage />} />
      <Route path="/p" element={<PortalPage />} />
      <Route path="/v" element={<VoucherLinkPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
